import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PersonIcon from '@mui/icons-material/Person';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import AssessmentIcon from '@mui/icons-material/Assessment';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import PieChartIcon from '@mui/icons-material/PieChart';
import BarChartIcon from '@mui/icons-material/BarChart';
import PublicIcon from '@mui/icons-material/Public';
import '../stylesheets/Main.css';

const Sidebar = () => {
  const [selectedNavItem, setSelectedNavItem] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname.substring(1) || 'dashboard';
    setSelectedNavItem(currentPath);
  }, [location.pathname]);

  const handleNavItemClick = (item) => {
    setSelectedNavItem(item);
    navigate(`/${item}`);
  };

  const getNavItemClass = (item) => {
    return selectedNavItem === item ? 'nav-item selected' : 'nav-item';
  };

  return (
    <div className="nav-sidebar-container">
      <div className="nav-items">
        <div style={{ display: 'flex' }} className={getNavItemClass('dashboard')} onClick={() => handleNavItemClick('dashboard')}>
          <DashboardIcon style={{ marginTop: '4px' }} />
          <span> Dashboard </span>
        </div>
        <div style={{ display: 'flex' }} className={getNavItemClass('manage-users')} onClick={() => handleNavItemClick('manage-users')}>
          <PersonIcon style={{ marginTop: '4px' }} />
          <span> User Management </span>
        </div>
        <div style={{ display: 'flex' }} className={getNavItemClass('pending-approval')} onClick={() => handleNavItemClick('pending-approval')}>
          <CleaningServicesIcon style={{ marginTop: '4px' }} />
          <span> Pending Approval </span>
        </div>
        <div style={{ display: 'flex' }} className={getNavItemClass('history')} onClick={() => handleNavItemClick('history')}>
          <WorkHistoryIcon style={{ marginTop: '4px' }} />
          <span> History </span>
        </div>
        {(JSON.parse(localStorage.getItem("adminData"))?.role?.permissions?.includes("Can view report") ||
          (JSON.parse(localStorage.getItem("adminData")).superAdmin)) &&
          <>
            <div style={{ display: 'flex' }} className={getNavItemClass('pie-chart')} onClick={() => handleNavItemClick('pie-chart')}>
              <AssessmentIcon style={{ marginTop: '4px' }} />
              <span> Reports </span>
            </div>
            <div style={{ display: 'flex', margin: '0px', marginLeft: '40px' }} className={getNavItemClass('pie-chart')} onClick={() => handleNavItemClick('pie-chart')}>
              <PieChartIcon style={{ marginTop: '4px' }} /> 
              <span> Waste composition </span>
            </div>
            <div style={{ display: 'flex', margin: '0px', marginLeft: '40px' }} className={getNavItemClass('column-chart')} onClick={() => handleNavItemClick('column-chart')}>
              <BarChartIcon style={{ marginTop: '4px' }} /> 
              <span> Waste volume </span>
            </div>
            <div style={{ display: 'flex', margin: '0px', marginLeft: '40px' }} className={`${getNavItemClass('map-chart')}`} onClick={() => handleNavItemClick('map-chart')}> 
              <PublicIcon style={{ marginTop: '4px' }} /> 
              <span> Real time detection </span>
            </div>
          </>
        }
      </div>
    </div>
  );
};

export default Sidebar;
